import _ from "lodash";
import { dateToString, getDifferenceInCalendarDays } from "../utils/date/date";
import { Entity } from "./Entity.abstract";

export class AutomaticIntegrationEntity extends Entity {
    constructor(props) {
        super(props);
    }

    static restore(props) {
        return new AutomaticIntegrationEntity(props);
    }

    disconnect() {
        this.props.connection = {};
    }

    setConnectionConfig({ connectionConfig }) {
        _.set(this.props, "connection", connectionConfig);
    }

    setConnection({ accountingId, connectionConfig, userId, connectionId }) {
        this.props = {
            _id: this.props._id,
            accountingId,
            system: "Dominio",
            connection: connectionConfig,
            createdAt: new Date(),
            createdBy: userId
        };
    }

    setId(id) {
        this.props._id = id;
    }

    setEncoding(encoding) {
        this.props.connection.encoding = encoding;
    }

    getToRemove() {
        const connection = {};
        if (this.props.system === "Dominio") connection.dominio = {};
        if (this.props.system === "eSocial") connection.eSocial = {};
        return {
            _id: this.props._id,
            accountingId: this.props.accountingId,
            system: this.props.system,
            connection
        };
    }

    getToSave() {
        const connection = {};
        if (this.props.system === "Dominio")
            connection.dominio = this.props.connection;
        if (this.props.system === "eSocial")
            connection.eSocial = this.props.connection;
        return {
            accountingId: this.props.accountingId,
            system: this.props.system,
            connection
        };
    }

    getToUpdate() {
        const connection = {};
        if (this.props.system === "Dominio")
            connection.dominio = this.props.connection;
        if (this.props.system === "eSocial")
            connection.eSocial = this.props.connection;
        return {
            _id: this.props._id,
            accountingId: this.props.accountingId,
            system: this.props.system,
            connection
        };
    }

    setCertificateExpirationInfo() {
        const dueDate = this.props.connection?.dueDate;
        if (!dueDate) {
            this.props.certificateExpirationInfo = {
                daysToExpire: null,
                formattedDueDate: null,
                labelDate: null
            };
            return;
        }

        const daysToExpire = Math.max(
            getDifferenceInCalendarDays(dueDate, new Date()),
            0
        );
        const formattedDueDate = dateToString(dueDate, "dd/MM/yyyy");
        const unit = daysToExpire < 2 ? "dia" : "dias";
        const labelDate = `${daysToExpire} ${unit}`;

        const requestAuthorization = this.props.connection
            ?.requestAuthorization;
        const isValidating =
            !requestAuthorization?.isAuthorized &&
            [
                "Validação de certificado solicitada. Aguardando resposta.",
                "Certificado em validação."
            ].includes(requestAuthorization?.message);
        const isInvalid =
            !requestAuthorization?.isAuthorized &&
            requestAuthorization?.message;
        !isValidating;
        const status = isValidating
            ? "validation"
            : isInvalid
            ? "error"
            : daysToExpire <= 0
            ? "expired"
            : daysToExpire <= 15
            ? "expiringSoon"
            : false;

        this.props.certificateExpirationInfo = {
            daysToExpire,
            formattedDueDate,
            labelDate,
            status
        };
    }
}
